import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import PanToolIcon from "@mui/icons-material/PanTool";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import Swal from "sweetalert2";

const OfferPauseInsurance = ({ state, setState }) => {
  const navigate = useNavigate();
  const [months, setMonths] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleMonthsChange = (event) => {
    setMonths(event.target.value);
  };

  const handleAceptPause = async () => {
    const result = await Swal.fire({
      title: "Estás a punto de pausar tu seguro",
      text: `¿Estás seguro que deseas continuar con la pausa de ${months} mes${
        months > 1 ? "es" : ""
      }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00BBEE",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      // Usuario confirmó la acción
      setIsLoading(true);
      try {
        await saveNotAnswersLanding({
          landingId: state.currentLanding,
          state,
          sessionID: state.sessionID,
          prevForm: state.prevForm,
          metadata: {
            monthsToPause: months,
            pid: state.product.id,
            pType:  state.product.type
          },
        });
        navigate(`/formulario/cancelacion/aceptar-pausa?uid=${state.userId}`);
      } catch (error) {
        console.log("[Error ACEPTING PAUSE]:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("Acción de pausa cancelada");
    }
  };

  return (
    <>
      {/* Título de la página */}
      <TitleHeaders
        title={`${state.userName}, entendemos que casi no uses tu ${
          state.isADevice ? "dispositivo 📱." : "vehículo 🚗🏍️."
        }`}
      />

      {/* Texto descriptivo */}
      <Typography variant="body1" sx={{ marginBottom: 2, color: "#000" }}>
        Por eso te ofrecemos la opción de pausar tu cobertura hasta por 3 meses
        <span role="img" aria-label="wink">
          😉
        </span>
      </Typography>

      {/* Lista de beneficios */}
      <Typography variant="body2" sx={{ marginBottom: 2, color: "#000" }}>
        Aquí te contamos algunos beneficios de pausar en lugar de cancelar tu
        cobertura:
        <ul>
          <li>Sigues acumulando meses en tu programa de lealtad.</li>
          <li>
            Puedes reactivar tu seguro en cualquier momento antes de que termine
            la pausa.
          </li>
          <li>
            No pierdes tu prima, y al evitar la cancelación, podrías ahorrarte
            costos si decides reactivar más adelante.
          </li>
        </ul>
      </Typography>

      {/* Select para elegir los meses */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 4,
          marginTop: 4,
        }}
      >
        <FormControl variant="standard" sx={{ minWidth: 120 }}>
          <InputLabel>Meses</InputLabel>
          <Select value={months} onChange={handleMonthsChange} label="Meses">
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="body1" sx={{ marginLeft: 2 }}>
          meses
        </Typography>
      </Box>
      <Box
        textAlign={"center"}
        justifyContent={"center"}
        width={"100%"}
        display={"flex"}
        padding={0}
        margin={0}
      >
        <Box
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 1,
            margin: "0px auto",
            fontSize: "20px",
            fontWeight: 600,
            width: "100%",
            borderRadius: "20px",
            backgroundColor: "#00BBEE",
            textAlign: "center",
            color: "#fff",
          }}
          onClick={handleAceptPause}
        >
          {isLoading ? (
            <CircularProgress sx={{ color: "#fff" }} />
          ) : (
            <>
              <PanToolIcon
                sx={{ marginRight: 1, color: "#fff" }}
                fontSize="medium"
              />
              Pausar seguro
            </>
          )}
        </Box>
      </Box>

      {/* Botón de pausar seguro */}
    </>
  );
};

export default OfferPauseInsurance;
